import {
  IDLE,
  IDLE_2,
  SLIDE,
  RUN,
  CROUCH,
  ATTACK,
  ATTACK_2,
  ATTACK_3,
  ATTACK_4,
  ATTACK_5,
  ATTACK_6,
  JUMP,
  JUMP_2,
  RIGHT,
  LEFT,
} from "./constants";

export function getHeroAnimation(type, w, h) {
  const animations = {
    [IDLE]: [
      { sX: 0, sY: 0 },
      { sX: w, sY: 0 },
      { sX: w * 2, sY: 0 },
      { sX: w * 3, sY: 0 },
    ],
    [IDLE_2]: [
      { sX: w * 3, sY: h * 5 },
      { sX: w * 4, sY: h * 5 },
      { sX: w * 5, sY: h * 5 },
      { sX: w * 6, sY: h * 5 },
    ],
    [RUN]: [
      { sX: w, sY: h },
      { sX: w * 2, sY: h },
      { sX: w * 3, sY: h },
      { sX: w * 4, sY: h },
      { sX: w * 5, sY: h },
      { sX: w * 6, sY: h },
    ],
    [JUMP]: [
      { sX: 0, sY: h * 2 },
      { sX: w, sY: h * 2 },
      { sX: w * 2, sY: h * 2 },
      { sX: w * 3, sY: h * 2 },
      { sX: w * 4, sY: h * 2 },
      { sX: w * 5, sY: h * 2 },
      { sX: w * 6, sY: h * 2 },
      { sX: 0, sY: h * 3 },
      { sX: w, sY: h * 3 },
      { sX: w * 2, sY: h * 3 },
      { sX: 0, sY: h * 2 },
      { sX: w, sY: h * 2 },
    ],
    [JUMP_2]: [
      // { sX: 0, sY: h * 2 },
      { sX: w, sY: h * 2 },
      { sX: w * 2, sY: h * 2 },
      { sX: w * 3, sY: h * 2 },
      { sX: w * 4, sY: h * 2 },
      { sX: w * 5, sY: h * 2 },
      { sX: w * 6, sY: h * 2 },
      { sX: 0, sY: h * 3 },
      { sX: w, sY: h * 3 },
      { sX: w * 2, sY: h * 3 },
      // { sX: 0, sY: h * 2 },
      // { sX: w, sY: h * 2 },
    ],
    [SLIDE]: [
      { sX: w * 3, sY: h * 3 },
      { sX: w * 4, sY: h * 3 },
      { sX: w * 5, sY: h * 3 },
      { sX: w * 6, sY: h * 3 },
      { sX: 0, sY: h * 4 },
    ],
    [ATTACK]: [
      { sX: 0, sY: h * 6 },
      { sX: w, sY: h * 6 },
      { sX: w * 2, sY: h * 6 },
      { sX: w * 3, sY: h * 6 },
      { sX: w * 4, sY: h * 6 },
      { sX: w * 5, sY: h * 6 },
      { sX: w * 6, sY: h * 6 },
      // { sX: 0, sY: h * 7 },
      // { sX: w, sY: h * 7 },
      // { sX: w * 2, sY: h * 7 },
      // { sX: w * 3, sY: h * 7 },
    ],
    [ATTACK_2]: [
      // { sX: 0, sY: h * 6 },
      // { sX: w, sY: h * 6 },
      // { sX: w * 2, sY: h * 6 },
      // { sX: w * 3, sY: h * 6 },
      // { sX: w * 4, sY: h * 6 },
      // { sX: w * 5, sY: h * 6 },
      { sX: w * 6, sY: h * 6 },
      { sX: 0, sY: h * 7 },
      { sX: w, sY: h * 7 },
      { sX: w * 2, sY: h * 7 },
      { sX: w * 3, sY: h * 7 },
    ],
    [ATTACK_3]: [
      { sX: w * 6, sY: h * 7 },
      { sX: 0, sY: h * 8 },
      { sX: w, sY: h * 8 },
      { sX: w * 2, sY: h * 8 },
    ],
    [ATTACK_4]: [
      { sX: w * 2, sY: h * 13 },
      { sX: w * 3, sY: h * 13 },
      { sX: w * 4, sY: h * 13 },
      { sX: w * 5, sY: h * 13 },
      { sX: w * 6, sY: h * 13 },
      { sX: 0, sY: h * 14 },
      { sX: w, sY: h * 14 },
    ],
    [ATTACK_5]: [
      { sX: w * 2, sY: h * 14 },
      { sX: w * 3, sY: h * 14 },
      { sX: w * 4, sY: h * 14 },
      { sX: w * 5, sY: h * 14 },
      { sX: w * 6, sY: h * 14 },
      { sX: 0, sY: h * 15 },
      { sX: w, sY: h * 15 },
      { sX: w * 2, sY: h * 15 },
      { sX: w * 3, sY: h * 15 },
    ],

    [CROUCH]: [
      { sX: w * 4, sY: 0 },
      { sX: w * 5, sY: 0 },
      { sX: w * 6, sY: 0 },
      { sX: w * 0, sY: h },
    ],
  };
  return animations[type];
}
